import React, { useState } from "react";
import { useForm } from 'react-hook-form';
import emailjs from 'emailjs-com';

const contactData = {
  phone: ["+234 8108 927010"],
  email: ["abioduntimileyin19@gmail.com"],
  location: "Remote, Anywhere and Everywhere.",
};

const Contact = () =>  {

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();

  const onSubmit = async (data) => {
    const { name, email, subject, message } = data;

    try {
      const dataToSubmit = {
        name, email, subject, message
      }

      await emailjs.send(
          process.env.REACT_APP_SERVICE_ID,
          process.env.REACT_APP_TEMPLATE_ID,
          dataToSubmit,
          process.env.REACT_APP_USER_ID
      );
      reset();
      setError(false);
      setMessage('Message Sent Successfully!');

    } catch (e) {
      setError(true);
      setMessage('An Error Occurred. Please try again!');
      console.log(e)
    }
  }

  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");

  const handleAlerts = () => {
    if (error && message) {
      return <div className="alert alert-danger alert-dismissible mt-4">{message}</div>;
    } else if (!error && message) {
      return <div className="alert alert-success alert-dismissible mt-4">{message}</div>;
    } else {
      return null;
    }
  };

  return (
        <div className="row">
          <div className="col-md-4 mb-4 mb-md-0">
            <div className="contact-info mb-5">
              <i className="icon-phone"></i>
              <div className="details">
                <h5>Phone</h5>
                {contactData.phone.map((singlePhone, index) => (
                    <span key={index}>{singlePhone}</span>
                ))}
              </div>
            </div>
            <div className="contact-info mb-5">
              <i className="icon-envelope"></i>
              <div className="details">
                <h5>Email address</h5>
                {contactData.email.map((singleEmail, index) => (
                    <span key={index}>{singleEmail}</span>
                ))}
              </div>
            </div>
            <div className="contact-info">
              <i className="icon-location-pin"></i>
              <div className="details">
                <h5>Location</h5>
                <span>{contactData.location}</span>
              </div>
            </div>
          </div>

          <div className="col-md-8">
            <form className="contact-form" onSubmit={handleSubmit(onSubmit)} noValidate>
              <div className="row">
                <div className="column col-md-6">
                  <div className="form-group">
                    <input
                        type="text"
                        className="form-control"
                        name="name"
                        { ...register('name', {
                          required: { value: true, message: 'Please enter your name' },
                          maxLength: {
                            value: 40,
                            message: 'Please use 30 characters or less'
                          }
                        }) }
                        placeholder="Your name"
                    />
                    { errors.name && <span className="text-danger">{errors.name.message}</span> }
                  </div>
                </div>

                <div className="column col-md-6">
                  <div className="form-group">
                    <input
                        type="email"
                        className="form-control"
                        name="email"
                        { ...register('email', {
                          required: true,
                          pattern: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                        })}
                        placeholder="Email address"
                    />
                    { errors.email && (
                        <span className="text-danger">Please enter a valid email address</span>
                    )}
                  </div>
                </div>

                <div className="column col-md-12">
                  <div className="form-group">
                    <input
                        type="text"
                        className="form-control"
                        name="subject"
                        { ...register('subject', {
                          required: { value: true, message: 'Please enter a subject' },
                          maxLength: {
                            value: 85,
                            message: 'Subject cannot exceed 85 characters'
                          }
                        }) }
                        placeholder="Subject"
                    />
                    { errors.subject && (
                        <span className="text-danger">{errors.subject.message}</span>
                    ) }
                  </div>
                </div>

                <div className="column col-md-12">
                  <div className="form-group">
                <textarea
                    name="message"
                    { ...register('message', {
                      required: true
                    })}
                    className="form-control"
                    rows={5}
                    placeholder="Message"
                ></textarea>
                    { errors.message && <span className="text-danger">Please enter a message</span> }
                  </div>
                </div>
              </div>

              <button
                  type="submit"
                  className="btn btn-default"
              >
                <i className="icon-paper-plane"></i>Send Message
              </button>
            </form>
            {handleAlerts()}
          </div>
        </div>
  )
}

export default Contact;
